const usePhoneContent = () => {
  return {}
}

export default usePhoneContent
